<template>
    <div v-if="currentEvent.status < 3" ref="menu" class="event-manage-menu">
        <div class="menu">
            <button
                v-if="mode !== 'artistEvent'"
                @click="menuOpen = !menuOpen"
                class="kebab-menu-btn"
            >
                <img :src="getImage('menu-dots.png')" />
            </button>
            <div v-if="menuOpen" class="event-menu">
                <button
                    v-if="currentEvent.event_type === 0 && currentEvent.status >= 2"
                    @click="() => viewEvent(currentEvent.id)"
                    class="menu-item"
                >
                    View event
                </button>
                <button @click="() => editEvent()" class="menu-item">Edit</button>
                <hr style="height: 1px; background-color: #888585; margin: 0" />
                <button
                    v-if="currentEvent.bid_artists_info.length > 0"
                    @click="() => cancelEvent(currentEvent.id)"
                    class="menu-item"
                >
                    Cancel event
                </button>
                <button
                    v-if="!currentEvent.bid_artists_info.length"
                    @click="() => deleteEvent(currentEvent.id)"
                    class="menu-item"
                >
                    Delete event
                </button>
            </div>
        </div>
        <EditModal ref="edit" :current-event="currentEvent" />
        <DeleteModal ref="delete" :current-event="currentEvent" />
        <CancelModal ref="cancel" :current-event="currentEvent" />
    </div>
</template>
<script>
    import { useAssets } from '@/composables/utils/useAssets'
    import EditModal from './EditModal.vue'
    import DeleteModal from './DeleteModal.vue'
    import CancelModal from './CancelModal.vue'

    export default {
        name: 'EventManageMenu',
        components: {
            EditModal,
            DeleteModal,
            CancelModal
        },
        props: {
            currentEvent: {
                type: Object,
                required: true
            }
        },
        setup() {
            const { getImage } = useAssets()

            return {
                getImage
            }
        },
        data: () => ({
            menuOpen: false
        }),
        methods: {
            viewEvent(id) {
                this.currentEvent.event_type === 0
                    ? (this.window.location = '/event/show/' + id)
                    : (this.window.location = '/event/show-preview/' + id)
            },
            editEvent() {
                if (this.$refs.edit) {
                    this.$refs.edit.$bvModal.show('modal-edit-event')
                } else {
                    console.error('Edit event modal ref not found')
                }
            },
            deleteEvent() {
                if (this.$refs.delete) {
                    this.$refs.delete.$bvModal.show('modal-delete-event-venue')
                } else {
                    console.error('Delete event modal ref not found')
                }
            },
            cancelEvent() {
                if (this.$refs.cancel) {
                    this.$refs.cancel.$bvModal.show('modal-cancel-event-venue')
                } else {
                    console.error('Cancel event modal ref not found')
                }
            },
            clickedDocument(event) {
                const targetElement = this.$refs.menu

                if (targetElement && !targetElement.contains(event.target)) {
                    this.menuOpen = false
                }
            }
        },
        mounted() {
            document.addEventListener('click', this.clickedDocument)
        },
        beforeDestroy() {
            document.removeEventListener('click', this.clickedDocument)
        }
    }
</script>
<style lang="scss" scoped>
    .event-manage-menu {
        position: relative;

        .menu {
            .kebab-menu-btn {
                border: none;
                background: none;
                padding: 0;
                margin: 0;
            }
            .event-menu {
                padding: 12px;
                display: inline-flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                border-radius: 8px;
                background: #464646;
                box-shadow: 0 6px 12px -6px rgba(0, 0, 0, 0.5);
                position: absolute;

                .menu-item {
                    font-size: 14px;
                    letter-spacing: 0.14px;
                    line-height: 130%;
                    min-width: max-content;
                    margin-bottom: 0;
                    color: inherit;
                    background: none;
                    border: none;
                    padding: 0;
                }
            }
        }
    }
</style>
